import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { EmployerDto } from '../../../service/dto';
import { HttpEmployerService } from '../../../service/http-employer.service';

@Component({
  selector: 'app-employer-list',
  standalone: false,
  templateUrl: './employer-list.component.html',
  styleUrl: './employer-list.component.scss'
})
export class EmployerListComponent {
	data: EmployerDto[] = [];
	constructor(private httpService: HttpEmployerService, private router: Router){

	}
	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => this.data=result);
	}

	doView(input: EmployerDto){
		this.router.navigate(['/employer',input.id,'edit']);
	}
}
